import { serializeArray } from '../components/utilities';

const Webforms = {
  submitWebForm: async function (form) {
    if (form.querySelector('[name="reply_to"]'))
      form.querySelector('[name="reply_to"]').value = form.querySelector('[name="email"]').value;

    const formName = form.getAttribute('name');
    const formButton = form.querySelector('button[type="button"]');

    let formData = serializeArray(form);
    if (formData.includes('&password')) formData = formData.split('&password')[0];

    if (!form.classList.contains('-sending')) {
      form.classList.add('-sending');
      form.classList.remove('error');

      try {
        const response = await fetch('/webform', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: formData,
        });

        if (response.ok) {
          console.info('Formulário enviado com sucesso');

          if (formName == 'newsletter' && formButton) {
            formButton.innerText = formButton.getAttribute('data-msg-success');
          } else if (formName == 'contato' && formButton) {
            formButton.innerHTML = formButton.getAttribute('data-msg-success');
            form.hasAttribute('data-form-request')
              ? (form.querySelector('textarea').value = '')
              : form.reset();
          } else {
            form.classList.add('-sent');
            form.querySelector('.msg-success').classList.add('-visible');
            form.reset();

            setTimeout(function () {
              form.classList.remove('-sent');
              form.querySelector('.msg-success').classList.remove('-visible');

              if (formName == 'orcamento') {
                let removes = document.querySelectorAll('.cart-buttons-trash');
                console.log('removes', removes);
                if (removes.length > 0)
                  removes.forEach((remove) => {
                    remove.click();
                  });
              }
            }, 3500);
          }
        } else {
          const text = await response.text();

          console.error(`Ocorreu um erro no envio do formulário. Erro ${response.status}`);
          console.error(text);

          if (formName == 'newsletter' && formButton) {
            formButton.innerText = formButton.getAttribute('data-msg-error');
          } else if (formName == 'contato' && formButton) {
            formButton.innerHTML = formButton.getAttribute('data-msg-error');
          } else {
            form.classList.add('error');
            form.querySelector('.msg-error').classList.add('-visible');

            setTimeout(function () {
              form.classList.remove('error');
              form.querySelector('.msg-error').classList.remove('-visible');
            }, 3500);
          }
        }
      } catch (error) {
        console.error('Erro ao enviar o webform');
        console.error(error);

        if (formName == 'newsletter' && formButton) {
          formButton.innerText = formButton.getAttribute('data-msg-error');
        } else if (formName == 'contato' && formButton) {
          formButton.innerHTML = formButton.getAttribute('data-msg-error');
        } else {
          form.classList.add('error');
          form.querySelector('.msg-error').classList.add('-visible');

          setTimeout(function () {
            form.classList.remove('error');
            form.querySelector('.msg-error').classList.remove('-visible');
          }, 3500);
        }
      }

      if (formName == 'newsletter' && formButton) {
        setTimeout(() => {
          formButton.innerText = 'ASSINAR';
          form.classList.remove('-sending');
        }, 3500);
      } else if (formName == 'contato' && formButton) {
        setTimeout(() => {
          formButton.innerHTML = 'Enviar';
          form.classList.remove('-sending');
        }, 3500);
      } else {
        form.classList.remove('-sending');
      }
    }
  },
  submitNotify: async function (form) {
    const formData = serializeArray(form);

    if (!form.classList.contains('-sending')) {
      form.classList.remove('error');

      try {
        const response = await fetch('/lista_de_espera', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: formData,
        });

        if (response.ok) {
          // Envia um webform de aviso de cadastro
          console.log('Lista de espera enviada com sucesso');
          Webforms.submitWebForm(form);
        } else {
          const text = await response.text();
          console.error(
            `Ocorreu um erro ao enviar o formulário de Lista de Espera. Erro ${response.status}`
          );
          console.error(text);

          form.classList.add('error');
          form.querySelector('.msg-error').classList.add('-visible');

          setTimeout(() => {
            form.classList.remove('error');
            form.querySelector('.msg-error').classList.remove('-visible');
          }, 3500);
        }
      } catch (error) {
        console.error('Falha ao enviar lista de espera. Verificar integração.');
        console.error(error);

        form.classList.add('error');
        form.querySelector('.msg-error').classList.add('-visible');

        setTimeout(() => {
          form.classList.remove('error');
          form.querySelector('.msg-error').classList.remove('-visible');
        }, 3500);
      }
    }
  },
  showMessage: function (input, form) {
    let alertMessage = form.querySelector('[data-msg]');
    if (!alertMessage) return;

    alertMessage.classList.add('-visible');
    alertMessage.innerText = 'Preencha os campos obrigatórios.';
    input.classList.add('-emphasis');

    setTimeout(() => {
      alertMessage.classList.remove('-visible');
      alertMessage.innerText = '';
      input.classList.remove('-emphasis');
    }, 2000);
  },
  validateForm: function (vndaInput, form) {
    let submitAllowed = true;

    // Permite o envio se o input vnda estiver vazio
    if (vndaInput.value == '') {
      vndaInput.setAttribute('required', false);

      // Valida se os campos obrigatórios estão preenchidos
      const requiredFields = form.querySelectorAll('[required]:not([required=false])');
      requiredFields.forEach((input) => {
        if (input.value == '') {
          submitAllowed = false;
          Webforms.showMessage(input, form);
        }

        if (input.type == 'checkbox' && input.checked == false) {
          submitAllowed = false;
          Webforms.showMessage(input, form);
        }

        if (input.type == 'email' && !input.value.includes('@')) {
          submitAllowed = false;
        }
      });

      if (submitAllowed)
        form.id == 'form-notify' ? Webforms.submitNotify(form) : Webforms.submitWebForm(form);
    }
  },
  setWebForms: function () {
    const webForms = document.querySelectorAll('[data-webform]:not(.-set)');

    webForms.length > 0 &&
      webForms.forEach((form) => {
        form.classList.add('-set');

        const button = form.querySelector('button');
        const fieldset = form.querySelector('fieldset');

        // Controla campos de telefone
        const inputs = form.querySelectorAll('input[name="phone"]');
        if (inputs.length)
          inputs.forEach((input) => {
            input.addEventListener('input', function (e) {
              var x = e.target.value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
              e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
            });
          });

        // Desabilita os campos do formulário, através do fieldset, quando o input vnda recebe algum valor
        let vndaInput = form.querySelector('input[name="vnda"]');
        vndaInput.addEventListener('input', () => fieldset.setAttribute('disabled', true));

        // Realiza o envio através do clique e da tecla enter sobre o botão do formulário
        button && button.addEventListener('click', () => Webforms.validateForm(vndaInput, form));
        button &&
          button.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') Webforms.validateForm(vndaInput, form);
          });
      });
  },
  init: function () {
    const _this = this;
    _this.setWebForms();
  },
};

export default Webforms;
